<template>
    <PopoverRight ref="popoverContent" width="700px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">话题分配</h1>
            <div class="tips-wrapper clearfix">
                <div class="left">操作提示：</div>
                <div class="right">
                    <p>1.此功能用于给站点下的楼盘，随机批量新增楼盘话题。</p>
                    <p>2.单次可给站点下的楼盘添加1-10个话题，请按需添加</p>
                </div>
            </div>
            <el-form class="form-container" :rules="rules" :model="formList" ref="topicsAssForm">
                <div class="form-item site-sp" >
                    <div class="site-label">
                        <span class="label">站点：</span>
                        <label class="warn">*</label>
                        <label class="ipt"
                        ><input
                            type="checkbox"
                            class="checkbox"
                            @click="selectAll"
                            :checked="checkAll"
                        />全选</label
                        >
                        <label class="ipt"
                        ><input
                            type="checkbox"
                            class="checkbox"
                            @click="selectStatus"
                            :checked="checkOwn"
                        />未代理站点</label
                        >
                    </div>
                    <br />
                    <div class="form-input-site">
                        <div v-if="this.siteList.length > 0">
                        <label v-for="(item, key) in siteList" :key="key">
                            <input
                            :id="key"
                            type="checkbox"
                            :value="item.id"
                            v-model="checkedSite"
                            />{{ item.name }}
                        </label>
                        </div>
                        <div v-else>暂无数据</div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">话题添加数量</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item>
                            <el-col :span="5">
                                <el-form-item prop="min_num">
                                    <el-input placeholder="最小值"  v-model="formList.min_num"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" style="text-align: center;">至</el-col>
                            <el-col :span="5">
                                <el-form-item prop="max_num">
                                    <el-input placeholder="最大值"  v-model="formList.max_num"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" style="text-align: center;">(可输入1-10,最小值不可大余最大值) </el-col>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">话题状态</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="">
                            <el-radio-group v-model="formList.is_all_topic">
                                <el-radio :label="1">只添加有关联问答的话题</el-radio>
                                <el-radio :label="2">全部话题都可添加</el-radio>
                            </el-radio-group>                        
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">楼盘话题状态</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="">
                            <el-radio-group v-model="formList.is_all_house">
                                <el-radio :label="1">只给无楼盘话题的楼盘添加</el-radio>
                                <el-radio :label="2">全部楼盘都可添加</el-radio>
                            </el-radio-group>                        
                        </el-form-item>
                    </div>
                </div>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button type="primary" @click="submitForm('topicsAssForm')" >确定</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { getSite } from "@/service/site";
import { parseTime } from '@/utils'
import {topicAssigned} from '@/service/topicBank'

export default {
    name: 'add',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
    },
    data () {
        const validateSort = (rule, value, callback) => {
               if (/^-?\d+$/.test(value) === false || value <1 || value >10) {
                    callback(new Error(`请输入1-10`))
                }else if(parseInt(this.formList.min_num)>parseInt(this.formList.max_num)){
                    callback(new Error(`最小值不可大余最大值`))
                }else {
                    callback()
                }
            }
        return {
            checkAll: false,
            checkOwn: false,
            siteList: [],
            checkedSite: [],
            formList:{
                is_all_topic:1,
                is_all_house:1,
                min_num:"",
                max_num:""
            },
            rules: {
                min_num: [
                    { required: true, message: '最小值', trigger: 'blur' },
                    { validator: validateSort,trigger: "blur"}
                ],
                max_num:[
                    { required: true, message: '最大值', trigger: 'blur' },
                    { validator: validateSort,trigger: "blur"}
                ]
            },
            topicId:null,

        }
    },
    watch: {
        checkedSite: function () {
        if (
            this.checkedSite.length == this.siteList.length &&
            this.checkedSite.length > 0
        ) {
            this.checkAll = true;
            this.checkOwn = false;
        } else {
            this.checkAll = false;
        }
        },
    },

    mounted(){

    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (id) {
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        selectAll(event) {
            var _this = this;
            if (!event.currentTarget.checked) {
                this.checkedSite = [];
                this.checkOwn = false;
            } else {
                _this.checkedSite = [];
                _this.siteList.forEach(function (item) {
                _this.checkedSite.push(item.id);
                });
            }
        },
        selectStatus(event) {
            var _this = this;
            if (!event.currentTarget.checked) {
                _this.checkedSite = [];
                _this.checkOwn = false;
            } else {
                getSite({ agent_status: 1, per_page: 1000 }).then((data) => {
                let noStatus = data.data;
                _this.checkedSite = [];
                noStatus.forEach((el) => {
                    _this.checkedSite.push(el.id);
                });
                _this.checkOwn = true;
                });
            }
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.topicsAssForm && this.$refs.topicsAssForm.clearValidate()
        },
        resetForm () {
            this.formList = {
                is_all_topic:1,
                is_all_house:1,
                min_num:"",
                max_num:""
            }
            this.checkedSite = [];
        },
         submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if(this.checkedSite.length<=0){
                        this.$message({
                            type: "error",
                            message: "请选择站点",
                        });
                        return;
                    }
                    let query = this.formList;
                    query.site_ids =this.checkedSite.join("_");
                    topicAssigned(query).then((data) => {
                        this.$message({
                            message: '分配成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                        this.callback && this.callback();
                    }).catch(err => {
                        this.$message({
                            message: err.message || '分配失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            })
        },
    }
}
</script>
<style scoped>
.site-sp {
  display: block !important;
  padding-left: 30px;
}
.site-label {
  width: 100%;
  height: 30px;
}
.site-label .ipt {
  margin-right: 20px;
}
.form-input-site {
  min-height: 100px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 20px;
  box-sizing: border-box;
}
.form-input-site label {
  margin-right: 15px;
  padding-bottom: 10px;
  display: inline-block;
}
.form-input-site label input {
  margin-right: 5px;
}
.popover-slider-bar .form-container .form-item .form-label {
    width: 25%;
}
.popover-slider-bar .form-container .form-item .form-input-item {
    width: 75%;
}
.tips-wrapper{
    width: 100%;
    margin-top:20px;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: right;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}
</style>